import React from "react";
import { useFormContext } from "react-hook-form";
import { getString } from "../../utilities";
import TextViewHook from "./textViewHook";
import { getMaxLengthValidator, validateAlphaNumeric } from "../../utilities/forms/rules";
import { ACCESS_NAME_CHAR_LIMIT, PASSWORD_CHAR_LIMIT, getSearchParamString } from "../../config";
import routeCodes from "../../config/routeCodes";

export default function StudentFields({
  hasStudentAccess,
  submitErrors,
  setSubmitErrors,
  isDisabled,
  studentAccessData,
}) {
  const {
    formState: { errors },
  } = useFormContext();

  const onChange = () => {
    if (submitErrors) {
      setSubmitErrors(null);
    }
  };

  const renderChildren = (item) => {
    if (hasStudentAccess && !!studentAccessData) {
      return (
        <div className="form-field-children">
          <div className="label">{getString("manage.accountInfo.current")}</div>
          <div className="current-value">{studentAccessData[item]}</div>
        </div>
      );
    }

    return null;
  };

  const renderAccessUrl = () => {
    if (hasStudentAccess && !!studentAccessData) {
      return (
        <div className="manage-account-url">
          <div className="label">{getString("manage.accountInfo.student.autoURL")}</div>
          <div className="current-value">{`${window.location.origin}${routeCodes.LOGIN}?${getSearchParamString("name")}=${studentAccessData.accessName}&${getSearchParamString("code")}=${
            studentAccessData.accessCode
          }`}</div>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <div className="cta">{getString("subscribe.student")}</div>
      <div className="cta-caption">{getString("subscribe.accessDesc")}</div>

      <TextViewHook
        rules={{
          validate: {
            lowAndNo: (value) => validateAlphaNumeric(getString("forms.accessName"), value),
            required: (value) =>
              hasStudentAccess ||
              !!value ||
              getString("forms.errorMessages.isRequired.0", { replace: [getString("forms.accessName")] }),
          },
          maxLength: getMaxLengthValidator(getString("forms.accessName"), ACCESS_NAME_CHAR_LIMIT),
        }}
        errors={errors}
        className="col2"
        name="accessName"
        placeholder={getString("forms.accessName")}
        label={getString("forms.accessName")}
        onChange={onChange}
        isDisabled={isDisabled}
      >
        {renderChildren("accessName")}
      </TextViewHook>

      <TextViewHook
        rules={{
          validate: (value) =>
            hasStudentAccess ||
            !!value ||
            getString("forms.errorMessages.isRequired.0", { replace: [getString("forms.accessCode")] }),
          maxLength: getMaxLengthValidator(getString("forms.accessCode"), PASSWORD_CHAR_LIMIT),
        }}
        errors={errors}
        className="col2 right"
        name="accessCode"
        placeholder={getString("forms.accessCode")}
        label={getString("forms.accessCode")}
        onChange={onChange}
        isDisabled={isDisabled}
      >
        {renderChildren("accessCode")}
      </TextViewHook>

      {renderAccessUrl()}
    </>
  );
}
